export default __webpack_public_path__ + "0d4d8fbd31179bcba69216019db1666a.png";